var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useRequest } from '../../../hooks/requestHook';
import { bulkCreate as bulkCreateDeliveryRequestsApi, } from '../../../api/deliveryRequest';
import DeliveryRequestsForm from './DeliveryRequestsForm';
var DeliveryRequestsNewForm = function (_a) {
    var roaster = _a.roaster, warehouseItems = _a.warehouseItems, onSuccess = _a.onSuccess, isAdmin = _a.isAdmin;
    var t = useTranslation().t;
    var _b = React.useState('oneTime'), deliveryRequestFormType = _b[0], setDeliveryRequestFormType = _b[1];
    var initialFormValues = React.useMemo(function () { return ({
        store_name: (roaster === null || roaster === void 0 ? void 0 : roaster.storeName) || '',
        person_name: t('fullname', roaster) || '',
        name_kana: (roaster === null || roaster === void 0 ? void 0 : roaster.nameKana) || '',
        phone: (roaster === null || roaster === void 0 ? void 0 : roaster.phone) || '',
        country_calling_code: (roaster === null || roaster === void 0 ? void 0 : roaster.countryCallingCode) || '',
        postal_code: (roaster === null || roaster === void 0 ? void 0 : roaster.postalCode) || '',
        prefecture: (roaster === null || roaster === void 0 ? void 0 : roaster.prefecture) || '',
        city: (roaster === null || roaster === void 0 ? void 0 : roaster.city) || '',
        address: (roaster === null || roaster === void 0 ? void 0 : roaster.address) || '',
        building: (roaster === null || roaster === void 0 ? void 0 : roaster.building) || '',
        vat_number: (roaster === null || roaster === void 0 ? void 0 : roaster.vatNumber) || '',
        eori_number: (roaster === null || roaster === void 0 ? void 0 : roaster.eoriNumber) || '',
        note: '',
    }); }, [roaster, t]);
    var bulkCreateDeliveryRequests = useRequest(bulkCreateDeliveryRequestsApi);
    var onRequest = React.useCallback(function (values, deliveryRequestGroup) { return __awaiter(void 0, void 0, void 0, function () {
        var params;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    params = {
                        delivery_request_group: {
                            address: {
                                store_name: values.store_name,
                                person_name: values.person_name,
                                name_kana: values.name_kana,
                                phone: values.phone,
                                country_calling_code: values.country_calling_code,
                                postal_code: values.postal_code,
                                prefecture: values.prefecture,
                                city: values.city,
                                address: values.address,
                                building: values.building,
                                note: values.note,
                            },
                            vat_number: values.vat_number,
                            eori_number: values.eori_number,
                            campaign_code: values.campaign_code,
                            delivery_requests: deliveryRequestGroup.itemsAndRequestDates.map(function (_a) {
                                var itemsAttributes = _a.itemsAttributes, requestDate = _a.requestDate;
                                return ({
                                    items: itemsAttributes.map(function (_a) {
                                        var warehouseItemId = _a.warehouseItemId, quantity = _a.quantity;
                                        return ({
                                            warehouse_item_id: warehouseItemId || '',
                                            quantity: quantity,
                                        });
                                    }),
                                    request_date: requestDate,
                                });
                            }),
                        },
                    };
                    if (isAdmin) {
                        params.roaster_id = roaster.id;
                    }
                    return [4 /*yield*/, bulkCreateDeliveryRequests(params)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    }); }, [bulkCreateDeliveryRequests, isAdmin, roaster.id]);
    if (warehouseItems.length <= 0)
        return null;
    return (React.createElement(DeliveryRequestsForm, { roaster: roaster, deliveryRequests: [], warehouseItems: warehouseItems.map(function (item) {
            return __assign(__assign({}, item), { deliveryRequestedQuantity: 0 });
        }), initialFormValues: initialFormValues, deliveryRequestFormType: deliveryRequestFormType, onChangeDeliveryRequestFormType: setDeliveryRequestFormType, onRequest: onRequest, onSuccess: onSuccess, isNew: true, isAdmin: isAdmin }));
};
export default DeliveryRequestsNewForm;
